/*
 * Writing section data. Curated to posts with relevance to a technical or professional audience.
 * Personal/lifestyle posts are excluded from the portfolio display.
 * Full archive at https://saitejapro.medium.com
 */
export const blogData = [
    {
        id: 1,
        title: 'Five Years Later, I Finally Understand What That Plane Ride Cost Me',
        description: 'Nobody tells you that moving across the world is the easy part.',
        date: 'Jun 2026',
        image: 'https://cdn-images-1.medium.com/max/1024/1*rx0QN91cosWwTJ4EFs8OYA.jpeg',
        url: 'https://saitejapro.medium.com/five-years-later-i-finally-understand-what-that-plane-ride-cost-me-636ffef3f4ad'
    },
    {
        id: 2,
        title: 'The Strangest Number in Tech Right Now',
        description: "Everyone is arguing about whether AI is a bubble. The more interesting question is what happens to the rest of us if it pops.",
        date: 'Jun 2026',
        image: 'https://cdn-images-1.medium.com/max/1024/1*NZYLa1cegl-4BS_CikX4qw.jpeg',
        url: 'https://saitejapro.medium.com/the-strangest-number-in-tech-right-now-97e8eb48acd2'
    },
    {
        id: 3,
        title: 'Model Context and the Protocol Behind It',
        description: 'The invisible infrastructure of human-AI communication.',
        date: 'Sept 2025',
        image: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/1*YiE4lKP2UbOB24jtFhtu0A.png',
        url: 'https://saitejapro.medium.com/model-context-and-the-protocol-behind-it-the-invisible-infrastructure-of-human-ai-communication-190313965c7b'
    },
    {
        id: 4,
        title: 'Functional Dissatisfaction',
        description: 'When nothing is wrong, but something still needs to change.',
        date: 'Jan 2026',
        image: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/1*y4_Vt460lMo9cb09Nb2RBw.png',
        url: 'https://saitejapro.medium.com/functional-dissatisfaction-64f701693092'
    }
]
